import React from 'react';
import Twilio from 'components/twilio';
import RtcChatBackdrop from 'components/chat/video_call/RtcChatBackdrop';
import { ConversationContextWrapper } from './twilio/ConversationContext';

const ChatSwitch = ({ children }) => (
  <ConversationContextWrapper>
    <Twilio />
    <RtcChatBackdrop />
    {children}
  </ConversationContextWrapper>
);

export default ChatSwitch;
